import DeleteButton from '@src/components/common/button/DeleteButton';
import { ButtonProps } from 'antd/lib/button';
import { get } from 'lodash';
import React from 'react';

// -- Prop types
// ----------
export interface IDeleteElementButtonOwnProps<T> {
  item?: T;
  titlePropPath?: string;
  customNameRender?: React.ReactNode;
  buttonText?: string;
  confirmText?: string;
  icon?: React.ReactNode;
  iconOnly?: boolean;
  className?: string;
  buttonProps?: Omit<ButtonProps, 'onClick' | 'className'>;

  onDelete?: (item: T) => any;
}

type IDeleteElementButtonProps<T> = IDeleteElementButtonOwnProps<T>;

// -- Component
// ----------

/** Display generic delete element with custom confirmation item title  */
const DeleteElementButton = <T, >(props: IDeleteElementButtonProps<T>) => {

  const getItemTitle = () => {

    if (props.item) {
      return props.customNameRender ?? get(props.item, props.titlePropPath ?? 'title');
    }
    return;
  };

  const handleDelete = () => {
    if (props.item) {
      props.onDelete?.(props.item);
    }
  };

  return (
    <DeleteButton
      onConfirm={() => handleDelete()}
      itemTitle={getItemTitle()}
      confirmText={props.confirmText}
      buttonText={props.buttonText}
      iconOnly={props.iconOnly}
      className={props.className}
      buttonProps={props.buttonProps}
      icon={props.icon}
    />
  );
};

// -- HOCs and exports
// ----------

export default DeleteElementButton;
